import { toNumber } from "lodash";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router";

import {
  useOrganizationQuery,
  OrganizationType,
} from "@/features/organization/graphql/generated";

export const useOrganisation = (id?: number) => {
  const orgId = id || toNumber(localStorage.getItem("recentOrg"));
  const navigate = useNavigate();

  const { data, loading, refetch } = useOrganizationQuery({
    variables: { id: orgId! },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip: !orgId,
    onError: () => {
      navigate("/org", { replace: true });
    },
  });

  const organization = useMemo(
    () => data?.organization || ({} as OrganizationType),
    [data?.organization]
  );

  const handleOrganisationSelect = (organisation: OrganizationType) => {
    window.localStorage.setItem(
      "recentOrg",
      organisation?.id?.toString() || ""
    );

    const redirectUrl = localStorage.getItem("accountSwitchRedirect");
    if (redirectUrl) {
      localStorage.removeItem("accountSwitchRedirect");
      navigate(redirectUrl);
      return;
    }

    navigate("/dashboard");
    refetch({ id: organisation?.id! });
  };

  return {
    organization,
    loading,
    handleOrganisationSelect,
  };
};
